import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var ForbiddenError = function ForbiddenError() {
    _classCallCheck(this, ForbiddenError);
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/forbidden.js
// module id = ./src/abstractions/errors/forbidden.js
// module chunks = 34